// The role set, shared by the server and the browser client so both accept the same
// values. `pm` and `ie` get no user-management rights: what they may see is decided
// by `getAccess` (src/lib/access.ts), not here.

import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements } from "better-auth/plugins/admin/access";

export const ac = createAccessControl(defaultStatements);

export const roles = {
  admin: adminAc,
  pm: ac.newRole({ user: [], session: [] }),
  ie: ac.newRole({ user: [], session: [] }),
};
